import { Group, Paper, Stack, Text, Title } from '@mantine/core'
import { IconHelpCircle } from '@tabler/icons-react'

import { Screen } from '@/components/Screen'
import { expertHelpContent } from '@/configs/expertHelpContent'
import { programManagerHelpContent } from '@/configs/programManagerHelpContent'
import useCheckMobileScreen from '@/hooks/useCheckMobileScreen'
import { useGlobalState } from '@/hooks/useGlobalState'

import { HelpSubSectionRenderer } from './HelpSubSectionRenderer'

export function HelpScreen() {
  const email = 'support@sidekickplatform.com'
  const isMobile = useCheckMobileScreen()
  const {
    authenticationStore: { isSponsorAdmin },
  } = useGlobalState()

  const helpContent = isSponsorAdmin ? programManagerHelpContent : expertHelpContent

  return (
    <Screen title="FAQs" icon={IconHelpCircle} BodyStackProps={{ gap: 'xl' }}>
      <Paper p="xl" radius="md" withBorder>
        <Group align="flex-start" w="100%">
          {!isMobile && (
            <Title order={6} fw={600} w={'25%'} style={{ flexShrink: 0 }}>
              Need Help?
            </Title>
          )}
          <Stack pr="xl" style={{ flex: 1 }}>
            <Text>
              Here are the answers to some of our most frequently asked questions. If you have other questions, try
              asking your Sidekick in the mobile app for even more information about how to use the Portal and the app.
              If you still haven&apos;t found what you&apos;re looking for, please contact the Sidekick Customer Success
              team at{' '}
              <Text component="a" href={`mailto:${email}`} c="blue">
                {email}
              </Text>
            </Text>
          </Stack>
        </Group>
      </Paper>

      {helpContent.map(section => (
        <Stack key={section.title}>
          <Title order={4}>{section.title}</Title>
          {section.subSections.map((subSection, index) => (
            <HelpSubSectionRenderer key={index} subSection={subSection} level={1} />
          ))}
        </Stack>
      ))}
    </Screen>
  )
}
